import {
  CdkStepper,
  StepperSelectionEvent
} from '@angular/cdk/stepper';
import { DatePipe } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { LimitRulesType } from 'src/app/@core/constants';
import { Customer } from 'src/app/models/customer';
import { JobInfo } from 'src/app/models/customer-job-info';
import { Paging } from 'src/app/models/page';
import { Param } from 'src/app/models/param';
import { PreApproveCustomerParams } from 'src/app/models/params/preApprove-customer-params';
import { PreApprovalChangeEvent } from 'src/app/models/preApprovalChangeEvent';
import { CustomerUpdateJobInfoRequest } from 'src/app/models/requests/customer-update-jobInfo-request';
import { CreditStatusFranchisedResponseModel } from 'src/app/models/response/customerCreditStatusResponseModel';
import { OnbaseProcedureResponseModel } from 'src/app/models/response/onbaseProcedureResponseModel';
import { PreApproveCustomerResponseModel } from 'src/app/models/response/preApproveCustomerResponseModel';
import { CustomerTableModel } from 'src/app/models/table-models/customer-table';
import { User } from 'src/app/models/user';
import { CreditService } from 'src/app/services/credit.service';
import { CustomerService } from 'src/app/services/customer.service';
import { ExceptionSolutionService } from 'src/app/services/exception-solution.service';
import { OnbaseService } from 'src/app/services/onbase.service';
import Swal from 'sweetalert2';
import { CustomerValidationsService } from '../../services/customer-validations.service';
import { ProductTableModel } from './../../../../models/table-models/product-table';
import { ConfigurationService } from './../../../../services/configuration.service';
import { CustomerCreditPlansComponent } from './../customer-credit-plans/customer-credit-plans.component';
import { CustomerPreApprovalFormComponent } from './../customer-pre-approval-form/customer-pre-approval-form.component';

@Component({
  selector: 'app-customer-credit-request-stepper',
  templateUrl: './customer-credit-request-stepper.component.html',
  styleUrls: ['./customer-credit-request-stepper.component.sass'],
})
export class CustomerCreditRequestStepperComponent implements OnInit {
  @ViewChild('customerPreApprovalFormComponent')
  customerPreApprovalFormComponent!: CustomerPreApprovalFormComponent;
  @ViewChild('customerCreditPlansComponent')
  customerCreditPlansComponent!: CustomerCreditPlansComponent;
  @ViewChild('cdkStepper') stepper!: CdkStepper;

  @Input() homeTypes: Array<Param> = new Array();
  @Input() currentCustomer: Customer = new Customer();
  @Input() preApprovalForm: FormGroup = new FormGroup({});
  @Input() productSelectionForm: FormGroup = new FormGroup({});
  @Input()
  currentCustomerCreditConditions: CreditStatusFranchisedResponseModel =
    new CreditStatusFranchisedResponseModel();
  @Input() selectedSeller: CustomerTableModel | User | undefined;

  @Output() quotationPlanClick: EventEmitter<boolean> = new EventEmitter(false);

  alreadyPreApproved = false;
  preApprovalFormValue: any;
  plans: Paging<Array<OnbaseProcedureResponseModel>> = new Paging([]);
  private isCanceled = false;
  public selectedProduct: ProductTableModel | undefined;

  constructor(
    private customerValidationsService: CustomerValidationsService,
    private onbaseService: OnbaseService,
    private configurationService: ConfigurationService,
    private customerService: CustomerService,
    private datePipe: DatePipe,
    private creditService: CreditService,
    private readonly exceptionSolutionService: ExceptionSolutionService
  ) { }

  async ngOnInit(): Promise<void> {
    // if (!this.showPreApprovalForm()) {
    //   await this.fetchCreditPlans();
    // }
  }

  handlePreApprovalInfoChange(
    preApprovalData: PreApprovalChangeEvent,
    stepper?: CdkStepper
  ): void {
    this.preApprovalFormValue = preApprovalData.preApprovalFormValue;
    // this.customerCreditPlansComponent.pathPreApprovalValueForm(
    //   preApprovalData.preApprovalFormValue
    // );
    this.plans = preApprovalData.plans;
    this.alreadyPreApproved = true;
  }

  async handleChangeStep(event: StepperSelectionEvent): Promise<void> {
    if (this.showPreApprovalForm()) {
      const sellerCode = this.isCustomer(this.selectedSeller)
        ? this.selectedSeller.code
        : this.selectedSeller!.username;

      if (event.selectedIndex === 2) {
        const customerInDefaultContinue =
          await this.customerValidationsService.validateCustomerInDefault(
            this.currentCustomer.code
          );

        const onBaseCreditStatusContinue =
          await this.customerValidationsService.validateOnBaseCreditStatus(
            this.currentCustomer.code
          );

        if (!customerInDefaultContinue || !onBaseCreditStatusContinue) {
          this.isCanceled = true;
          this.stepper.previous();
        } else if (!this.alreadyPreApproved) {
          const sellerCode = this.isCustomer(this.selectedSeller)
            ? this.selectedSeller.code
            : this.selectedSeller!.username;
          await this.customerPreApprovalFormComponent.handlePreApproveClick(
            sellerCode,
            this.selectedProduct!.code
          );
        }
      } else if (!this.alreadyPreApproved && event.selectedIndex === 2) {
        if (this.isCanceled) {
          this.isCanceled = false;
        } else {
          await this.customerPreApprovalFormComponent.handlePreApproveClick(
            sellerCode,
            this.selectedProduct!.code
          );
        }
      }
    } else {
      if (event.selectedIndex === 1) {
        await this.fetchCreditPlans();
      }
    }
  }

  resetStepper(): void {
    this.stepper.reset();
    this.alreadyPreApproved = false;
    this.plans = new Paging([]);
  }

  async fetchCreditPlans(): Promise<void> {
    const { branch, salesOrg } =
      this.configurationService.readSelectedBranchAndSalesOrg();

    const sellerCode = this.isCustomer(this.selectedSeller)
      ? this.selectedSeller.code
      : this.selectedSeller!.username;

    this.plans = (
      await this.onbaseService
        .readPreApproveCreditPlans(
          this.currentCustomer.code,
          branch.code,
          LimitRulesType.BURO,
          salesOrg.code,
          "",
          sellerCode
        )
        .toPromise()
    ).response;
  }

  handleSelectedProductChange(selectedProduct: ProductTableModel): void {
    this.selectedProduct = selectedProduct;
    const control = this.productSelectionForm.get('productCode')!;
    control.setValue(selectedProduct.code);
    control.markAsTouched();
    control.markAsDirty();
  }

  private async updateJobCustomerInfo(): Promise<void> {
    const request = this.buildUpdateJobInfoRequestModel();
    const response = await this.customerService
      .updateJobInfoCustomer(this.currentCustomer.code, request)
      .toPromise();
    console.log(response);
  }

  private buildUpdateJobInfoRequestModel(): CustomerUpdateJobInfoRequest {
    const updateJoInfoRequestModel: CustomerUpdateJobInfoRequest =
      new CustomerUpdateJobInfoRequest();

    updateJoInfoRequestModel.countryId = this.currentCustomer.mainPersonalInfo
      ?.nationality
      ? this.currentCustomer.mainPersonalInfo?.nationality
      : '';

    updateJoInfoRequestModel.houseType = this.preApprovalForm.value.homeType;

    updateJoInfoRequestModel.ownCar = this.preApprovalForm.value.ownVehicle;
    updateJoInfoRequestModel.personality = this.currentCustomer.mainPersonalInfo
      ?.personality
      ? this.currentCustomer.mainPersonalInfo?.personality
      : '';
    const currentCustomerJobInfo: JobInfo = new JobInfo();
    const transformWorkSeniority = this.datePipe.transform(
      this.preApprovalForm.value.workSeniority,
      `YYYYMMdd`
    )
      ? this.datePipe.transform(
        this.preApprovalForm.value.workSeniority,
        `YYYYMMdd`
      )
      : '';

    currentCustomerJobInfo.admissionDate = transformWorkSeniority
      ? transformWorkSeniority
      : '';

    currentCustomerJobInfo.currency = 'HNL';
    currentCustomerJobInfo.monthlySalary =
      this.preApprovalForm.value.monthIncome;
    updateJoInfoRequestModel.jobInfoList = [currentCustomerJobInfo];

    return updateJoInfoRequestModel;
  }

  handleIncomeChange(income: number): void {
    this.updateJobCustomerInfo();
  }

  private async preApprovePlan(
    preApproveCustomerParams: PreApproveCustomerParams
  ): Promise<PreApproveCustomerResponseModel> {
    return await this.creditService
      .getPreApproveCreditInfo(preApproveCustomerParams)
      .toPromise();
  }

  async handlePreApproveCreditPlan(preApproveCustomerParams: {
    preApproveParams: PreApproveCustomerParams;
    creditPlan: OnbaseProcedureResponseModel;
    monthIncome: number | undefined;
  }): Promise<void> {
    if (preApproveCustomerParams.monthIncome) {
      //first update income info on customer
      await this.updateJobCustomerInfo();
    }

    // then pre approve
    const preResponse = await this.preApprovePlan(
      preApproveCustomerParams.preApproveParams
    );

    this.creditService.setPreApprove({
      creditPlan: preApproveCustomerParams.creditPlan,
      isCreditRequestCreated: false,
      preApproveCode: preResponse.preApproveCode || '',
      preApproveAmount: preResponse.preApproveAmount || 0
    });

    if (
      (Number(preResponse.limiteCreditoPreaprobado) > 0 &&
        preResponse.tipoTramite !== '0004') ||
      (Number(preResponse.limiteCreditoPreaprobado) !== 2 &&
        preResponse.tipoTramite === '0004') ||
      preApproveCustomerParams.creditPlan.code === '0007' ||
      preApproveCustomerParams.creditPlan.code == '0010' ||
      preApproveCustomerParams.creditPlan.code == "0005"
    ) {
      Swal.fire({
        title: `Solicitudes de Crédito`,
        html: `Operación Exitosa </br> Por favor, ingrese la solicitud de crédito`,
        icon: 'success',
        confirmButtonText: 'Aceptar',
      });
      preApproveCustomerParams.creditPlan.preApprove = true;
      preApproveCustomerParams.creditPlan.credit = Number(
        preResponse.limiteCreditoPreaprobado || 0
      );
    } else {
      this.exceptionSolutionService.showAlertWithSolution('Solicitudes de Crédito', 'Lo sentimos, por los momentos este cliente no aplica a crédito');
      preApproveCustomerParams.creditPlan.preApprove = false;
    }
  }

  handleClickOnQuotationPlan(isClick: boolean) {
    this.quotationPlanClick.emit(isClick);
  }

  showPreApprovalForm(): boolean {
    if (this.currentCustomer.mainPersonalInfo?.personality === 'LEGAL_ENTITY') {
      return false;
    }

    if (this.currentCustomerCreditConditions.estadoCliente === 'EMP') {
      return false;
    }

    return true;
  }

  isCustomer(
    value: CustomerTableModel | User | undefined
  ): value is CustomerTableModel {
    return (value as CustomerTableModel).fullName !== undefined;
  }
}
